import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-feaedb50")

_pushScopeId("data-v-feaedb50")
const _hoisted_1 = { class: "ui__bannerModel_main" }
const _hoisted_2 = { class: "ui__bannerModel_bannerBox" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_swiperComponent = _resolveComponent("swiperComponent")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "ui__bannerModel_cover",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModel && _ctx.closeModel(...args)))
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_swiperComponent, {
        imgList: _ctx.state.photoList,
        initialSlide: -1
      }, null, 8, ["imgList"])
    ])
  ]))
})